import { render, staticRenderFns } from "./otro.vue?vue&type=template&id=dc3d06a2&scoped=true"
import script from "./otro.vue?vue&type=script&lang=js"
export * from "./otro.vue?vue&type=script&lang=js"
import style0 from "./otro.vue?vue&type=style&index=0&id=dc3d06a2&prod&scoped=true&lang=css"
import style1 from "./otro.vue?vue&type=style&index=1&id=dc3d06a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3d06a2",
  null
  
)

export default component.exports